<ui-modal
  [title]="modalTitle"
  description="Заполните все поля"
  [loading]="isLoadingData"
  [footer]="footerRef"
  (afterClose)="onAfterClose()"
  width="900px"
>
  <ui-form [form]="form" [config]="formConfig"> </ui-form>
</ui-modal>

<ng-template #footerRef>
  <ui-button
    type="primary"
    [block]="true"
    [loading]="isSaving"
    [disabled]="canNotSave"
    (click)="onSave()"
  >
    @if (isDetails) {
    <ui-icon name="save" size="20px"></ui-icon>
    <span> Сохранить </span>
    }@else {
    <ui-icon name="plus" size="20px"></ui-icon>
    <span> Добавить </span>
    }
  </ui-button>
</ng-template>
